export const toBase64Utf8 = (value) => {
	// value ожидается строкой (xml)
	const str = typeof value === 'string' ? value : String(value)
	const bytes = new TextEncoder().encode(str)
	let binary = ''
	for (let i = 0; i < bytes.length; i += 1) {
		binary += String.fromCharCode(bytes[i])
	}
	return window.btoa(binary)
}
